export enum LoginMode {
  NO_PASSWORD = "no_password",
  COMMON_PASSWORD = "common_password",
  INDIVIDUAL_PASSWORD = "individual_password"
}

export const BLOCKED_ODDBODS_CATEGORY = 'oddbods_books';
export const BLOCKED_BROB_MILESTONE_CODE = 'brob';

export const IS_SPLASH_LEAGUE_INTRO_PHASE = false //new Date() < new Date('2025-09-08');

export const IsSchoolUiDecoupledEnabled = () => {
  const cookies = document.cookie.split(';').reduce((acc, cookie) => {
    const [name, value] = cookie.trim().split('=');
    acc[name] = value;
    return acc;
  }, {});
  return (cookies?.['sui_decoupled'] === "1" || window.location.pathname.startsWith("/school_ui/"));
}

export const IsLeftNavDashboardV2 = () => {
  const cookies = document.cookie.split(';').reduce((acc, cookie) => {
    const [name, value] = cookie.trim().split('=');
    acc[name] = value;
    return acc;
  }, {});
  return (cookies?.['left_nav_dashboard'] === "v2") || (window?.left_nav_dashboard === 'v2');
}

export const getLeftNavDashboardVersion = () => {
  const cookies = document.cookie.split(';').reduce((acc, cookie) => {
    const [name, value] = cookie.trim().split('=');
    acc[name] = value;
    return acc;
  }, {});
  return cookies?.['left_nav_dashboard'] || window?.left_nav_dashboard;
}

export const X_CSRF_TOKEN = document.querySelector('meta[name=csrf-token]')?.getAttribute("content") || window.school_ui_web_manifest?.['csrf_token'];